import type { MessageContext } from 'vue-i18n'

// Seeded from tix-api-data/templates/portalstring i18n:* default_value.
// Extra keys below have no template — needed for ecomm-next listing.

function namedMembersSingleOptionalLabel(ctx: MessageContext): string {
  const role = String(ctx.named('role_name') ?? '')
  const article = 'aeiou'.includes(role[0]) ? 'an' : 'a'
  return `I would like to name ${article} ${role}.`
}

export const en = {
  'accountLinks.loginLinkLongLabel': 'Account login',
  'accountLinks.registerLinkLongLabel': 'Become a member',
  'accountLinks.registerLinkShortLabel': 'Membership',
  'applyGiftCards.applyAnotherGiftCard': 'Apply another gift card',
  'applyGiftCards.applyGiftCard': 'Apply a gift card',
  'applyGiftCards.modalTitle': 'Apply a gift card',
  'applyGiftCardsModal.giftCardNotFound': 'Gift card not found',
  'applyGiftCardsModal.giftCardNumberLabel': 'Gift card number',
  'applyPromoCodes:applyAnotherPromoCodeLabel': 'Apply another promo code',
  'applyPromoCodes:applyPromoCodeLabel': 'Apply a promo code',
  'availabilityStatus.soldOut': 'Sold out',
  'buyMembership.autoRenewal': 'Auto renewal',
  'buyMembership.autoRenewalSubtext': 'Automatically renew your membership.',
  'buyMembership.deleteCartOrCheckout.description':
    'You need to take action on your current cart before you can buy another membership.',
  'buyMembership.deleteCartOrCheckout.title': 'Buy membership',
  'buyMembership.no': 'No',
  'buyMembership.reserveButton': 'Add membership to cart',
  'buyMembership.yes': 'Yes, renew annually',
  'cancelAutoRenewRoute.body': 'Are you sure you want to unenroll your membership from automatic renewal?',
  'cancelAutoRenewRoute.cancel': 'Cancel',
  'cancelAutoRenewRoute.confirmUnenrollment': 'Confirm unenrollment',
  'cancelAutoRenewRoute.done': 'Done',
  'cancelAutoRenewRoute.notAuthenticatedError':
    'This membership does not appear to be enrolled in automatic renewal.<br/>Please <login-link>login</login-link> to view the details of your current membership.',
  'cancelAutoRenewRoute.notEnrolledError': 'This membership does not appear to be enrolled in automatic renewal.',
  'cancelAutoRenewRoute.successful':
    'Your <strong>{level}</strong> membership is successfully unenrolled. Please continue to use your membership until {valid_to}.',
  'cancelAutoRenewRoute.title': 'Cancel membership auto-renew',
  'cartWidget.discounts': 'Discounts',
  'cartWidget.fixedFees': 'Service charges',
  'cartWidget.percentFees': 'Tax',
  'cartWidget.title': 'Your cart',
  'cartWidget.total': 'Cart total',
  'checkoutRoute.ticketsEmailToMessage': 'Tickets will be emailed to <em>{email}</em> upon payment.',
  'checkoutRoute.title': 'Payment information',
  'checkoutRoute.yourInformation': 'Your information',
  'completedOrdersRoute.giftOrderNumber': 'Your gift order number is {number}',
  'completedOrdersRoute.ticketsOrderNumber': 'Your experience order number is {number}',
  'completedOrdersRoute.title': '<span>Done!</span> We look forward to your visit',
  'contextualEventTitles.membership': '',
  'contextualEventTitles.membershipRenew': 'Renew your membership',
  'eventListingItem.buttonText': 'Select',
  'eventListingRoute.title': 'Choose your events',
  'eventListingRoute.upsellsTitle': 'What other experiences would you like to add?',
  'forgotMembership.sendMembershipID': 'Send membership ID',
  'forgotMembership.title': 'Forgot your membership ID?',
  'forgotPasswordRoute.body':
    '<p>Enter the email address associated with your membership. We will send you a one-time link to reset your password.</p>',
  'forgotPasswordRoute.sendResetLink': 'Send reset link',
  'forgotPasswordRoute.title': 'Reset password',
  'homeRoute.guestTitle': 'Continue as a guest',
  'homeRoute.loginTitle': 'Already a member',
  'homeRoute.signupTitle': 'Become a member',
  'loginFlowStepEmail.becomeAMember': 'Become a member',
  'loginFlowStepEmail.loginHelpText': 'Enter your email address to receive a one-time login link and passcode.',
  'loginFlowStepEmail.loginWithOTPButton': 'Send login link',
  'loginFlowStepEmail.loginWithPasswordButton': 'Log in with password',
  'loginFlowStepEmail.notAMember': "Don't have a membership?",
  'loginFlowStepOTP.loginButton': 'Log in',
  'loginFlowStepPassword.forgotPassword': 'Forgot your password?',
  'loginFlowStepPassword.loginButton': 'Log in',
  'loginForm.becomeAMember': 'Become a member',
  'loginForm.forgotPassword': 'Set or reset your password here',
  'loginForm.lastNameLabel': 'Primary member last name',
  'loginForm.loginButton': 'Log in',
  'loginForm.loginHelpText': '',
  'loginForm.memberID': 'Member ID',
  'loginForm.notAMember': "Don't have a membership?",
  'loginForm.title': 'Account login',
  'loginOrGuestDialog.title': 'Are you a member?',
  'memberRoleLabels.member': 'member | members',
  'membersMenu.membershipDetails': 'Membership details',
  'membersOnly.description': 'This event is members only',
  'membersOnly.loginLinkLabel': 'Log in',
  'membersOnly.signupTemplate':
    'Not a member? <membership-link>Sign up</membership-link> to enjoy member exclusive events.',
  'membersOnly.title': 'Sorry!',
  'membershipForm.caption': 'Please edit the details of your membership',
  'membershipForm.lastMembershipLevel': 'Last membership level',
  'membershipForm.membershipExpiration': 'Membership expiration',
  'membershipForm.title': 'Edit your membership',
  'membershipLevel.membershipLevel': 'Membership level',
  'membershipLevel.showMoreLabel': 'Show all benefits',
  'membershipModal.membershipExpiration': 'Membership expiration',
  'membershipModal.membershipLevel': 'Membership level',
  'membershipModal.renewMembershipButton': 'Renew membership',
  'membershipModal.title': 'Membership details',
  'membershipRoute.gifteeHeader.caption': '',
  'membershipRoute.gifteeHeader.title': 'Recipient contact information',
  'membershipRoute.unavailableMessage': 'Memberships are not available at this time.',
  'namedMembers.multipleOptionalLabel': 'How many {role_name} would you like to name?',
  'namedMembers.multipleOptionalLabelMore': 'How many more {role_name} would you like to name?',
  // Template default is a static "a {role_name}"; function picks a/an like ecomm-previous English.ts.
  'namedMembers.singleOptionalLabel': namedMembersSingleOptionalLabel,
  'payButton.desktop.proceedButtonLabel': 'Proceed to checkout',
  'purchasedMembership.autoRenewContactMessage': 'Please contact us to enroll your membership for auto-renew.',
  'redeemMembershipRoute.input.description':
    'If you have received a gift of membership from someone, please enter the 10-digit code below to start the redemption process.',
  'redeemMembershipRoute.input.inputHeaderDescription': 'This is your unique 10-digit code',
  'redeemMembershipRoute.input.inputHeaderTitle': 'Gift of membership code',
  'redeemMembershipRoute.input.title': 'Redeem a gift of membership',
  'redeemMembershipRoute.membershipLevels.description':
    'The first membership is your gift, which you may upgrade at your cost if you wish',
  'redeemMembershipRoute.membershipLevels.label': 'Choose a membership',
  'redeemMembershipRoute.queryParam.description':
    'Looks like someone really likes you! You\u2019ve received a membership to experience great art, big ideas, and courageous conversations that can only be found here.',
  'redeemMembershipRoute.queryParam.title': 'Congratulations! You\u2019ve been gifted a membership!',
  'renewMembershipMessage.expired':
    'Your membership expired. <membership-link renew="true">Renew now</membership-link> to reserve members-only tickets on {ticketDate}.',
  'renewMembershipMessage.expiresIn':
    'Your membership expires {expiryDate}. <membership-link renew="true">Renew now</membership-link> to reserve members-only tickets on {ticketDate}.',
  'rescheduleRoute.costIncreaseWarning': 'The selected session time of {time} will incur an additional cost of {cost}',
  'rescheduleRoute.description':
    'Please choose a new date and time for the experience <strong>{name}</strong>,\n        currently booked for <strong>{count}</strong> on <strong>{date}</strong> at <strong>{time}</strong>.',
  'rescheduleRoute.title': 'Reschedule experience',
  'reserve.addOnHelpText': 'You can upgrade your experience by selecting this optional add-on.',
  'reserve.buttonLabel.donation': 'Add donation to cart',
  'reserve.buttonLabel.member': 'Add membership to cart',
  'reserve.buttonLabel.passes': 'Add passes to cart | Add 1 pass to cart | Add {count} passes to cart',
  'reserve.buttonLabel.tickets': 'Add tickets to cart | Add 1 ticket to cart | Add {count} tickets to cart',
  'reserve.fewTicketsWarning': 'Hurry, less than 10 tickets available.',
  'reserve.selectDateDescription': 'Which day would you like to visit?',
  'reserve.sessionUnavailable': 'Sorry, tickets for this event are not available at the selected time.',
  'reserve.skipAddOn': 'Skip add-on',
  'reserve.title': 'Select tickets',
  'reserveDateFirst.pickFlexibleTickets': 'Any day admission',
  'reserveDateFirst.singleDateAdmission': 'Single date admission',
  'selectAvailableSession.title': 'Select a time',
  'selectDate.placeholder': 'Pick a date',
  'selectSession.description': 'What time would you like to attend?',
  'stepperGroupDescriptions.default': 'Who is coming to this session?',
  'stepperGroupDescriptions.guests': 'Who is coming to this session?',
  'stepperGroupDescriptions.members': 'Who is coming to this session?',
  'stepperGroupDescriptions.passes': 'How many passes would you like?',
  'stepperGroupTitles.default': 'Select {type}',
  'stepperGroupTitles.giftOfMembershipDescription': 'What level of membership would you like to gift',
  'stepperGroupTitles.giftOfMembershipTitle': 'Select memberships',
  'stepperGroupTitles.guests': 'Select non-member {type}',
  'stepperGroupTitles.members': 'Select member {type}',
  'survey2.heading': 'We require some more information',
  'termsCheckbox.checkboxLabel': 'Please <a>read and accept the terms & conditions</a> to proceed with your order.',
  'termsModal.title': 'Terms & conditions',
  'ticketTypeSteppers.benefits': '{name} benefits',
  'unnamedMembers.label': 'Please specify the number of {role_name}.',
  // no template
  'membersBanner.welcomeBack': 'Welcome {name}!',
  'dateFilters.all': 'All dates',
  'categoryFilters.all': 'All',
  'date.today': 'Today',
  'date.tomorrow': 'Tomorrow',
  'availabilityStatus.available': 'Available',
  'availabilityStatus.nAvailable': '{count} left',

  /** Bare portal string keys from tix-api-data/templates/portalstring/misc.yaml (not i18n: / kiosk:). */
  'custom_strings.above_login': '',
  'custom_strings.before_resend_tickets': '',
  'custom_strings.cart_fees_name': 'Service Fee',
  'custom_strings.change_member_details_instructions': 'To change your membership details, please contact us.',
  'custom_strings.completed_order_links': '',
  'custom_strings.completed_order_message':
    '<p>We emailed your order confirmation to <em>{email}</em>.</p>  <p>Thank you for your purchase.</p>',
  'custom_strings.event_membership_promo':
    'Get access for a whole year with a <membership-link>membership</membership-link>.',
  'custom_strings.footer_text_links': '<p>© Ticketure</p>',
  'custom_strings.forgot_membership_id_link_text': 'Forgot Your Membership ID?',
  'custom_strings.forgot_membership_instructions':
    "Enter the email address associated with your membership, and we'll resend your membership number.",
  'custom_strings.forgot_password_contact_details':
    'If you do not receive a password reset email or if you would like to change details about your membership, please contact us.',
  'custom_strings.manage_order_message': '',
  'custom_strings.membership_presell_benefits_html': '',
  'custom_strings.membership_presell_guest_html': '',
  'custom_strings.members_banner':
    '<strong>Are you a member?</strong><br /><login-link>Log in</login-link> or <membership-link>sign up</membership-link> today.',
  'custom_strings.terms_and_conditions_dialog_content': '',
  'custom_strings.tickets_unavailable_message': 'Sorry, tickets are not available for this event.',
} as const

export type MessageKey = keyof typeof en
